import { type ExistingEmployeesByEmail } from 'modules/employees/lib/validateEmailForCreation'

import validateEmail from './validateEmail'
import validateEnum from './validateEnum'
import validateString from './validateString'
import validateStringDate from './validateStringDate'

type Props = {
  cellValue: string
  fieldType: string
  enumOptions?: string[]
  formats?: string[]
  existingEmployeesByEmail: ExistingEmployeesByEmail
}

const validator = ({
  cellValue,
  fieldType,
  enumOptions = [],
  formats = ['yyyy-MM-dd'],
  existingEmployeesByEmail,
}: Props) => {
  switch (fieldType) {
    case 'string':
      return validateString({ string: cellValue })
    case 'date':
      return validateStringDate({ stringDate: cellValue, formats })
    case 'email':
      return validateEmail({ email: cellValue.toLowerCase(), existingEmployeesByEmail })
    case 'enum':
      return validateEnum({ value: cellValue, options: enumOptions })
    default:
      return validateString({ string: cellValue })
  }
}

export default validator
